"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableCells = void 0;
const text_cell_1 = require("./cells/text-cell");
const number_cell_1 = require("./cells/number-cell");
const date_cell_1 = require("./cells/date-cell");
const date_time_cell_1 = require("./cells/date-time-cell");
const time_cell_1 = require("./cells/time-cell");
const boolean_cell_1 = require("./cells/boolean-cell");
const dictionary_column_mapper_1 = require("./cells/dictionary-column-mapper");
const select_column_mapper_1 = require("./cells/select-column-mapper");
exports.TableCells = {
    BooleanCell: boolean_cell_1.BooleanCell,
    TextCell: text_cell_1.TextCell,
    NumberCell: number_cell_1.NumberCell,
    DateCell: date_cell_1.DateCell,
    DateTimeCell: date_time_cell_1.DateTimeCell,
    TimeCell: time_cell_1.TimeCell,
    useSelectCellFactory: select_column_mapper_1.useSelectCellFactory,
    dictionaryColumnMapper: dictionary_column_mapper_1.dictionaryColumnMapper,
    dictionaryArrayColumnMapper: dictionary_column_mapper_1.dictionaryArrayColumnMapper,
};
//# sourceMappingURL=table-cells.js.map